/* tslint:disable:indent */
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {FormsEnum} from '../../../../models/enums/forms.enum';
import {Section} from '../../../../models/section';
import {FieldError} from './field-error';
import {StepperModels} from '../../../shared/models/stepper/stepper-model';
import {HttpClient} from '@angular/common/http';
import {StepError} from './step-error';
import {AvisDataTransferService} from '../../../shared/services/avis-data-transfer.service';
import {ContenuPdf} from '../../../formulaires/common/models/contenuPdf';
import {EformDataService} from '../../../formulaires/eforms/services/eform-data.service';
import {StepWarning} from './step-warning';
import {EformElementsService} from '../../../formulaires/eforms/services/efom-elements.service';

@Injectable({
  providedIn: 'root',
})
export class StepperBuilderService {

  eformSchematronsErrors = [];

  private stepStatsBhs: BehaviorSubject<Map<string, boolean>> = new BehaviorSubject(
    new Map<string, boolean>()
  );

  public index = 0;
  public subSections: number[] = [0.1, 0.2, 0.3, 0.4];
  public sections: Section[] = [];
  public formulaire: FormsEnum;
  private stepStats = new Map<string, boolean>();
  public facturationErrorCount = 0;
  public indexationErrorCount = 0;
  public annonceurErrorCount = 0;
  public validationErrorCount = 0;
  public errorsEformBySection: any[] = [];

  public facturationWarningCount = 0;

  // ✅ FIX 2026-03-02: Sauvegarder temporairement stepValue pour restaurer le bon lot/part
  public savedStepValue: number = null;

  public stepFieldsOnErrors = new Map<string, StepError>();
  public stepFieldsOnErrorsWithNoLocation = new Set<FieldError>();
  public stepFieldsOnWarnings = new Map<string, StepWarning>();
  public stepFieldsSpecificMessages = new Map<string, any>();

  public newError: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public newWarning: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public notice: BehaviorSubject<any> = new BehaviorSubject(null);
  public duplicableSection: BehaviorSubject<any> = new BehaviorSubject(null);
  public stepper: BehaviorSubject<any> = new BehaviorSubject(null);
  public avisId = null;

  public PDFAvisLiesSetted: BehaviorSubject<any> = new BehaviorSubject(null);
  public prefillDone: BehaviorSubject<any> = new BehaviorSubject(false);

  public isSavedBack: BehaviorSubject<boolean> = new BehaviorSubject(false);


  constructor(private http: HttpClient,
              private avisDataTransferService: AvisDataTransferService,
              private eformDataService: EformDataService,
              private eformElementsService: EformElementsService) {
  }

  public initDefaultMapErrors(path): void {
    this.http.get(path).subscribe(
      (steps: { [key: string]: { errors: FieldError[]; warnings: FieldError[]; isCheckValid: boolean } }) => {
        for (const stepId of Object.keys(steps)) {
          const stepData = steps[stepId];
          const stepError = new StepError();
          stepError.errors = stepData.errors;
          stepError.isCheckValid = stepData.isCheckValid;
          this.stepFieldsOnErrors.set(stepId, stepError);
          const stepWarning = new StepWarning();
          stepWarning.warnings = stepData.warnings;
          stepWarning.isCheckValid = stepData.isCheckValid;
          this.stepFieldsOnWarnings.set(stepId, stepWarning);
        }
      },
      (error) => {
        console.error('Error loading errors.json', error);
      }
    );
  }

  public initDefaultJsonErrors(path) {
    return this.http.get(path);
  }

  public prepareMapErrors(jsonFieldsErrorsWarnings) {
    const errors: Map<string, StepError> = new Map<string, StepError>(
      Object.keys(jsonFieldsErrorsWarnings).map(key => {
        const stepError = new StepError();
        stepError.errors = jsonFieldsErrorsWarnings[key].errors;
        stepError.isCheckValid = true;
        return [key, stepError];
      })
    );
    this.stepFieldsOnErrors = errors;
    const warnings: Map<string, StepWarning> = new Map<string, StepWarning>(
      Object.keys(jsonFieldsErrorsWarnings).map(key => {
        const stepError = new StepWarning();
        stepError.warnings = jsonFieldsErrorsWarnings[key].warnings;
        stepError.isCheckValid = true;
        return [key, stepError];
      })
    );
    this.stepFieldsOnWarnings = warnings;
  }

  public prepareJsonErrors() {
    const jsonFieldsErrorsWarningsObject = {};
    this.stepFieldsOnErrors.forEach((value, key) => {
      if (!jsonFieldsErrorsWarningsObject[key]) {
        jsonFieldsErrorsWarningsObject[key] = {errors: [], warnings: [], isCheckValid: false};
      }
      jsonFieldsErrorsWarningsObject[key].errors = value.errors;
      jsonFieldsErrorsWarningsObject[key].isCheckValid = value.isCheckValid;
    });
    this.stepFieldsOnWarnings.forEach((value, key) => {
      if (!jsonFieldsErrorsWarningsObject[key]) {
        jsonFieldsErrorsWarningsObject[key] = {errors: [], warnings: [], isCheckValid: false};
      }
      jsonFieldsErrorsWarningsObject[key].warnings = value.warnings;
    });
    return jsonFieldsErrorsWarningsObject;
  }

  public initDefaultFormAD(path): any {
    return this.http.get(path).subscribe(
      (json) => {
        this.avisDataTransferService.jsonCSV = json;
      },
      (error) => {
        console.error('Error loading errors.json', error);
      }
    );
  }

  public initFormLiePDF(path): any {
    return this.http.get(path);
  }

  public initDefaultFormPDF(path): any {
    return this.http.get(path).subscribe(
      (json) => {
        this.avisDataTransferService.contenuPdf = new ContenuPdf();
        this.avisDataTransferService.contenuPdf.champs = json;
      },
      (error) => {
        console.error('Error loading errors.json', error);
      }
    );
  }

  public haventFormErrors(): boolean {
    return Array.from(this.stepFieldsOnErrors.values()).every(stepError => stepError.errors.length === 0);
  }

  public deleteStepIntoStepper(index) {
    const eformNameDeleted = this.stepper.getValue().filter(step => step.id === index)[0]?.eformName;
    let stepperWithoutThisStep = this.stepper.getValue().filter(step => step.id !== index);

    stepperWithoutThisStep.forEach(step => {
      if (step.id > index) {
        step.id--;
        if (step.sections && step.sections.length > 0) {
          if(step.eformName === eformNameDeleted){
            step.value--;
          }
          step.sections.forEach(section => {
            // ✅ FIX 2026-05-06 : utiliser toFixed(1) pour éviter la perte de précision flottante
            // Exemple : 7.2 - 1 = 6.199999999999999 en JS, ce qui cassait findIndexPageForSpecificStep
            section.id   = parseFloat((section.id   - 1).toFixed(1));
            section.code = parseFloat((section.code - 1).toFixed(1));
          });
        }
      }
    });
    this.stepper.next(stepperWithoutThisStep);

    //On met à jour la liste des sous-sections
    let updatedSections = [];
    this.stepper.getValue().forEach(step => {
        if (step.sections && step.sections.length > 0) {
          step.sections.forEach(section => {
            updatedSections.push(section.code);
          })
        } else {
          updatedSections.push(step.id);
        }
      }
    );
    this.subSections = updatedSections;
  }
  public duplicateStepForStepper(sectionToDuplicate) {
    let stepToDuplicate = sectionToDuplicate;
    let stepper = this.stepper.getValue();
    //On vérifie si la step à dupliquer est la derniére qui porte ce nom si ce n'est pas le cas on actualise
    let actualLabel = sectionToDuplicate.libelle;
    stepper.forEach(step => {
      if (step.libelle === actualLabel && step.value > sectionToDuplicate.value) {
        stepToDuplicate = step;
      }
    })
    let stepIndex = stepToDuplicate.id;
    let newStep = JSON.parse(JSON.stringify(stepper[stepIndex]));
    newStep.id++;
    newStep.sections.forEach(section => {
      section.id++;
      section.code++;
    });

    //On ferme la section qui vient d'etre dupliquée
    stepper[stepIndex].required = false;

    //On met à jour les id des steps situées après celle à dupliquer ainsi que ceux des sections
    stepper.forEach(step => {
      if (step.id >= newStep.id) {
        step.id++;
        if (step.sections && step.sections.length > 0) {
          // Pour les steps eform, incrémenter normalement
          step.sections.forEach(section => {
            section.id++;
            section.code++;
          });
        }
      }
    });
    //On ajoute notre nouvelle step dans le stepper
    stepper.splice(stepIndex + 1, 0, newStep);

    //On met à jour la liste des sous-sections (utiliser code au lieu de id pour cohérence avec deleteStepIntoStepper)
    this.subSections = this.insertAndShift(sectionToDuplicate?.sections?.map(e=>e.code),this.subSections);

    //On met à jour value qui sert d'index pour les steps dupliquée
    let actualStepLabel = stepper[stepIndex].libelle;
    let index = 0
    stepper.forEach(step => {
      if (step.libelle === actualStepLabel) {
        index++;
      }
      newStep.value = index
    });
    //On met à jour le stepper
    this.stepper.next(stepper);
    //On retourne l'id de la step qu'on va ajouter afin de naviguer vers celle-ci directement
    return newStep.id;
  }

  public clearStepFieldsOnErrors(step) {
    const stepError = new StepError();
    stepError.errors = [];
    stepError.isCheckValid = this.getIsCheckValidate(step);
    if (this.stepFieldsOnErrors.has(step)) {
      this.stepFieldsOnErrors.set(step, stepError);
    }
    for (const key of this.stepStats.keys()) {
      this.stepStats.set(key, true);
    }
  }

  /**
   * Retire l'erreur d'un champ précis du bandeau d'une étape, sans attendre le prochain scan complet
   * (isFormValid). Utile pour les champs alimentés par une vérification asynchrone (ex : type d'entité
   * après vérification du SIRET) qui ne repassent pas par isFormValid une fois corrigés.
   */
  public removeFieldFromStepErrors(step: string, fieldName: string) {
    const stepError = this.stepFieldsOnErrors.get(step);
    if (stepError?.errors?.length) {
      stepError.errors = stepError.errors.filter(fieldError => fieldError.fieldName !== fieldName);
    }
    this.newError.next(true);
  }

  public insertAndShift(insertValues: number[], arr: number[]): number[] {
    // Vérifier si le premier élément de insertValues est présent dans arr
    const firstValue = insertValues[0];

    // Si le premier élément est présent dans arr, incrémenter les éléments supérieurs ou égaux
    if (arr.includes(firstValue)) {
        arr = arr.map(value => value >= firstValue ? value + 1 : value);
    }

    // Ajouter les éléments de insertValues dans arr
    arr = arr.concat(insertValues);

    // Trier le tableau arr par ordre croissant
    arr.sort((a, b) => a - b);

    return arr;
  }

  public clearAllStepFieldsOnErrors() {
    this.stepFieldsOnErrors.forEach(stepError => {
      stepError.errors = [];
    });
    this.stepFieldsOnErrorsWithNoLocation = new Set<FieldError>();
    for (const key of this.stepStats.keys()) {
      this.stepStats.set(key, true);
    }
  }

  public clearSpecificFieldOnErrors(step: string) {
    if (this.stepFieldsOnErrors.get(step)) {
      this.stepFieldsOnErrors.get(step).errors.length = 0;
    }
  }

  public clearStepFieldsOnWarnings(step) {
    const stepWarning = new StepWarning();
    stepWarning.warnings = [];
    stepWarning.isCheckValid = this.getIsCheckValidate(step);
    if (this.stepFieldsOnWarnings.has(step)) {
      this.stepFieldsOnWarnings.set(step, stepWarning);
    }
    for (const key of this.stepStats.keys()) {
      this.stepStats.set(key, true);
    }

  }

  public clearAllStepFieldsOnWarnings() {
    this.stepFieldsOnWarnings.forEach(stepWarning => {
      stepWarning.warnings = [];
    });
    for (const key of this.stepStats.keys()) {
      this.stepStats.set(key, true);
    }
  }


  public addStepFieldsOnErrors(stepId: string, fieldName: string, errorMessage: string) {
    if (errorMessage) {
      let haveNoLocation = false;

      if (stepId == 'undefined') {
        const stepperValue = this.stepper.getValue();
        if (stepperValue && stepperValue[1] && stepperValue[1].libelle) {
          stepId = stepperValue[1].libelle.split('|').pop() + '_0_0';
        } else {
          stepId = 'unknown_0_0';
        }
        haveNoLocation = true;
      }

      // Normaliser le stepId : remplacer ND- par GR- pour correspondre à la logique du stepper component
      // ...existing code...
      if (stepId && stepId.startsWith('ND-')) {
        stepId = stepId.replace(/^ND-/, 'GR-');
      }

      // Si le stepId est GR-Result_0_0, mapper vers la bonne sous-section selon le type duplicable dans fieldName
      // ...existing code...
      if (stepId === 'GR-Result_0_0' && fieldName && fieldName.includes('|')) {
        const parts = fieldName.split('|');
        if (parts.length > 1) {
          const duplicablePart = parts[1];
          if (duplicablePart.startsWith('Tender_')) {
            stepId = this.findSubSectionId(stepId, 'GR-LotTender-Section');
          } else if (duplicablePart.startsWith('Contract_')) {
            stepId = this.findSubSectionId(stepId, 'GR-SettledContract-Section');
          } else if (duplicablePart.startsWith('Tenderer_')) {
            stepId = this.findSubSectionId(stepId, 'GR-TenderingParty-Section');
          } else if (duplicablePart.startsWith('LotResult_')) {
            stepId = this.findSubSectionId(stepId, 'GR-LotResult-Section');
          }
        }
      }

      const fieldError: FieldError = new FieldError();
      fieldError.errorMessage = errorMessage;
      fieldError.fieldName = fieldName;

      if (!haveNoLocation) {
        let stepError = this.stepFieldsOnErrors.get(stepId);
        if (!stepError) {
          stepError = new StepError();
          stepError.errors = [];
          stepError.isCheckValid = false;
          this.stepFieldsOnErrors.set(stepId, stepError);
        }
        stepError.errors.push(fieldError);
      } else {
        this.stepFieldsOnErrorsWithNoLocation.add(fieldError);
      }
      this.newError.next(true);
    }
  }

  /**
   * Trouve l'ID de la sous-section correspondant à une section duplicable
   * @param parentStepId Le stepId parent (ex: GR-Result_0_0)
   * @param sectionKey La clé de la section (ex: GR-LotTender-Section)
   * @private
   */
  private findSubSectionId(parentStepId: string, sectionKey: string): string {
    const steps = this.stepper.getValue();
    if (!steps) return parentStepId;

    // Trouver le step parent
    for (const step of steps) {
      const stepIdStr = step.eformName ? step.eformName + '_0_0' : null;
      if (stepIdStr === parentStepId && step.sections && step.sections.length > 0) {
        // Chercher la sous-section qui correspond à sectionKey
        for (let i = 0; i < step.sections.length; i++) {
          const section = step.sections[i];
          // Le libellé de la section contient généralement la clé
          // Ex: "eform-not-editable.group|name|GR-LotTender-Section"
          if (section.intitule && section.intitule.includes(sectionKey)) {
            // Construire l'ID de la sous-section selon le format du stepper component
            // Format: eformName_(value-1)_sectionIndex
            const subSectionId = `${step.eformName}_${step.value - 1}_${i}`;
            return subSectionId;
          }
        }
      }
    }

    console.warn('✗ Sub-section not found, using parent:', { parentStepId, sectionKey });
    return parentStepId;
  }

  public addStep(stepId: string, isCheckValid: boolean) {
    if (!this.stepFieldsOnErrors.has(stepId) && !this.stepFieldsOnWarnings.has(stepId)) {
      const stepError = new StepError();
      stepError.errors = [];
      stepError.isCheckValid = isCheckValid;
      const stepWarning = new StepWarning();
      stepWarning.warnings = [];
      stepWarning.isCheckValid = isCheckValid;
      this.stepFieldsOnErrors.set(stepId, stepError);
      this.stepFieldsOnWarnings.set(stepId, stepWarning);
    } else {
      if (!this.stepFieldsOnErrors.has(stepId)) {
        const stepError = new StepError();
        stepError.errors = [];
        stepError.isCheckValid = isCheckValid;
        this.stepFieldsOnErrors.set(stepId, stepError);
      } else {
        this.stepFieldsOnErrors.get(stepId).isCheckValid = isCheckValid;
      }
      if (!this.stepFieldsOnWarnings.has(stepId)) {
        const stepWarning = new StepWarning();
        stepWarning.warnings = [];
        stepWarning.isCheckValid = isCheckValid;
        this.stepFieldsOnWarnings.set(stepId, stepWarning);
      } else {
        this.stepFieldsOnWarnings.get(stepId).isCheckValid = isCheckValid;
      }
    }
  }

  /*
  * Cette fonction permet de mettre à jour les tabIndex et les sections
  * @param tabStep
  */
  public updateStepList(tabStep: Section[], bool, id) {
    function isSame(element, index, array) {
      return (
        element.id === array[0].id &&
        element.code === array[0].code &&
        element.ordreFormulaire === array[0].ordreFormulaire &&
        element.intitule === array[0].intitule
      );
    }
  }


  public addStepFieldsOnWarnings(stepId: string, fieldName: string, errorMessage: string) {
    if (!this.stepFieldsOnWarnings.has(stepId)) {
      const stepWarning = new StepWarning();
      stepWarning.warnings = [];
      stepWarning.isCheckValid = false;
      this.stepFieldsOnWarnings.set(stepId, stepWarning);
    }
    const fieldError: FieldError = new FieldError();
    fieldError.errorMessage = errorMessage;
    fieldError.fieldName = fieldName;
    this.stepFieldsOnWarnings.get(stepId).warnings.push(fieldError);
    this.newWarning.next(true);
  }

  public getStepFieldsOnErrors(stepId: string): Array<FieldError> {
    // Ne pas transformer le stepId - utiliser la clé telle quelle
    if (this.stepFieldsOnErrors.has(stepId)) {
      return this.stepFieldsOnErrors.get(stepId).errors;
    } else {
      return [];
    }
  }

  public getStepFieldsOnErrorsWithoutLocation(): Set<FieldError> {
      return this.stepFieldsOnErrorsWithNoLocation;
  }

  public getIsCheckValidate(stepId: string): boolean {
    // Ne pas transformer le stepId - utiliser la clé telle quelle
    if (this.stepFieldsOnErrors.has(stepId)) {
      return this.stepFieldsOnErrors.get(stepId).isCheckValid;
    } else {
      return false;
    }
  }

  public setIsCheckValidate(stepId: string, value): void {
    // Ne pas transformer le stepId - utiliser la clé telle quelle
    if (this.stepFieldsOnErrors.has(stepId)) {
      this.stepFieldsOnErrors.get(stepId).isCheckValid = value;
    }
  }

  public getStepFieldsOnWarnings(stepId: string): Array<FieldError> {
    // Ne pas transformer le stepId - utiliser la clé telle quelle
    if (this.stepFieldsOnWarnings.has(stepId)) {
      return this.stepFieldsOnWarnings.get(stepId).warnings;
    } else {
      return [];
    }
  }

  public updateStats(stats: Map<string, boolean>) {
    stats.forEach((value, key) => {
      this.stepStats.set(key, value);
    });
    this.stepStatsBhs.next(this.stepStats);
  }

  public getStats(): Observable<Map<string, boolean>> {
    return this.stepStatsBhs.asObservable();

  }

  public findIndexPageForSpecificStep(stepId) {
    // ✅ FIX 2026-03-02: Chercher d'abord une correspondance exacte pour restaurer les sous-sections
    const exactMatch = this.subSections.find((subsection) => subsection === stepId);
    if (exactMatch !== undefined) {
      return exactMatch;
    }

    // Si pas de correspondance exacte, chercher avec startsWith
    const startsWithMatch = this.subSections.find((subsection) =>
      subsection.toString().startsWith(stepId.toString()));

    if (startsWithMatch !== undefined) {
      return startsWithMatch;
    }

    return undefined;
  }

  public getSubsectionIndex(): number {
    return this.subSections[this.index];
  }

  public removeIndex() {
    if (this.index > 0) {
      this.index--;
    }
  }

  public addIndex() {
    if (this.index < this.subSections?.length - 1) {
      this.index++;
    }
  }

  public resetSteps() {
    this.sections.splice(0, this.sections?.length);
    this.subSections = [0.1, 0.2, 0.3, 0.4];
    this.stepStats = new Map<string, boolean>();
    this.formulaire = null;
    this.index = 0;
    this.stepFieldsOnErrors = new Map<string, StepError>();
    this.stepFieldsOnWarnings = new Map<string, StepWarning>();
    this.facturationErrorCount = 0;
    this.facturationWarningCount = 0;
    this.indexationErrorCount = 0;
    this.annonceurErrorCount = 0;
  }

  public getFormulaire(): Observable<FormsEnum> {
    return new Observable((data) => {
      if (this.formulaire) {
        data.next(this.formulaire);
      }
    });
  }

  public getIndex(item) : number {
   let itemIndex = this.subSections.findIndex(elt => elt === item)
   return this.subSections[itemIndex+1];
  }

  /**
   * cette fonction permet de rajouter le formulaire adapté
   *
   */
  public addFAD(index, fadIndex, steps, formulaireName, isSelectedDiffuseurADMoreThanZero) {
    // si l'index est 0.4 (l'utilisateur vient de charger la liste de diffusion ) et que le numéro de la
    // step pour le formulaire adapté n'est pas encore calculé alors il faut rajouter l'étape
    if (!this.containsFAD(steps)) {
      if (fadIndex === null && isSelectedDiffuseurADMoreThanZero === true) {
        if (formulaireName === 'FORM_AD') {
          fadIndex = 1;
        } else if (steps?.length !== 0 && !steps[steps?.length - 1]?.libelle.includes('stepper.form.AD')) {
          //L'index le plus grand est step.length -1 auquel on ajoute 1 soit:
          fadIndex = Number(steps.length - 0.7).toFixed(1);
          //Creation d'une nouvelle step formulaire adapté
          const sectionFAD: Section = new Section();
          sectionFAD.id = 3;
          sectionFAD.code = fadIndex;
          sectionFAD.intitule = 'stepper.form.AD';
          steps[steps.length - 1]?.sections?.splice(2, 0, sectionFAD);
          for (let index = 3; index < steps[steps.length - 1]?.sections.length; index++) {
            steps[steps.length - 1].sections[index].code = Number(steps[steps.length - 1].sections[index].code + 0.1).toFixed(1);
            steps[steps.length - 1].sections[index].id = Number(steps[steps.length - 1].sections[index].id + 1);
          }
          this.subSections.push(+Number(this.subSections[this.subSections.length - 1] + 0.1).toFixed(1))
          // init all steps without errors
          this.clearStepFieldsOnErrors('_STEP_ID_' + index);
          this.clearStepFieldsOnErrors('_STEP_ID_SepSep_TypeFacturation');
          this.clearStepFieldsOnErrors('_STEP_ID_SepSep_TypeIndexation');
          this.clearStepFieldsOnErrors('_STEP_ID_SepSep_idAnnonceur');
          this.clearStepFieldsOnWarnings('_STEP_ID_' + index);
          this.clearStepFieldsOnWarnings('_STEP_ID_SepSep_TypeFacturation');
          this.clearStepFieldsOnWarnings('_STEP_ID_SepSep_TypeIndexation');
          this.clearStepFieldsOnWarnings('_STEP_ID_SepSep_idAnnonceur');
        }
      } else if (index > 0.3 && fadIndex !== null && fadIndex === steps[steps?.length - 1]?.value && isSelectedDiffuseurADMoreThanZero === false) {
        fadIndex = null;
        steps.pop();
      }
    }

    return {fadIndex, sections: steps};
  }

  containsFAD(steps: StepperModels[]) {
    return steps ? steps[steps.length - 1]?.libelle.includes('stepper.form.AD') : false;
  }

  removeLastControl(parentForm, pathElements, repeatablePathWithIndex, indexToDel?, listName?) {
    let currentElement = parentForm;
    let it = 0;
    for (const index in pathElements) {
      if (currentElement === null) {
        break;
      }
      it++;
      if (it === pathElements.length) {
        if (pathElements[index].includes('[]')) {
          const indexToRemove = indexToDel >= 0 ? indexToDel : this.eformDataService.getArrayIndex(pathElements[index], repeatablePathWithIndex);
          let ind = indexToRemove;
          const controlsArray = currentElement.controls[pathElements[index].replace('[]', '')];
          // 🔧 FIX 2026-02-16: Vérifier que l'index est valide avant de l'ajuster
          if (controlsArray.length > 0 && controlsArray.length === indexToRemove) {
            ind = ind - 1;
          }
          // S'assurer que l'index est dans les limites
          if (ind < 0) ind = 0;
          if (ind >= controlsArray.length) ind = controlsArray.length - 1;

          let controls = controlsArray.controls;
          // 🔧 FIX 2026-02-16: Utiliser ind (l'index ajusté) pour récupérer le préfixe
          let prefix = controls[ind]?.prefixEform?.split('_')[0];
          if (listName) {
            let fieldList = controlsArray.value;
            if (fieldList && fieldList.length > 0) {
              let elementPropertyName = Object.keys(fieldList[0])[0];
              for (let i = 0; i < fieldList.length; i++) {
                if (fieldList[i][elementPropertyName]?.listName === listName) {
                  if (ind === 0) {
                    ind = i;
                    break;
                  } else {
                    ind--;
                  }
                }
              }
            }
          }
          if (ind >= 0 && ind < controlsArray.length) {
            controlsArray.removeAt(ind);
          }
          this.updateIndexGreaterThanIndexToRemove(indexToRemove, controls, prefix);
        } else {
          currentElement.removeControl('val');
        }
      } else {
        if (pathElements[index].includes('[]')) {
          if (this.eformDataService.getArrayIndex(pathElements[index], repeatablePathWithIndex, true) === -1) {
            for (let i = 0; i < currentElement.get(pathElements[index].split('[]')[0]).length; i++) {
              if (currentElement.get(pathElements[index].split('[]')[0]).get(i.toString()).controls[pathElements[+index + 1].replace('[]', '')]) {
                currentElement = currentElement.get(pathElements[index].split('[]')[0]).get(i.toString());
                break;
              }
            }
          } else {
            currentElement = currentElement.get(pathElements[index].split('[]')[0]).get(this.eformDataService.getArrayIndex(pathElements[index], repeatablePathWithIndex).toString())
          }
        } else {
          currentElement = currentElement.get(pathElements[index])
        }
      }
    }
    return parentForm;
  }

  /**
   * On met à jour l'index de inputIndex et prefixEform quand c'est necessaire ( qd le prefix est le mm et l'index est supérieur à celui supprimé)
   * @param indexToRemove
   * @param currentElement
   * @param pathElements
   * @param index
   */
  updateIndexGreaterThanIndexToRemove(indexToRemove, controls, prefix) {
    controls.forEach(control => {
      if (!control.idInput) { return; }
      control.idInput = this.decrementLastIndex(control.idInput, indexToRemove);
      if (!control.idInput.includes('|')) {
        control.prefixEform = this.decrementLastIndex(control.prefixEform, indexToRemove);
      }
    });
  }

  decrementLastIndex(idInput: string, indexSuppression: number): string {
    const parts = idInput.split('|');
    const lastPart = parts[parts.length - 1];

    const match = lastPart.match(/^(.*_)(\d+)$/);
    if (!match) return idInput;

    const prefix = match[1];
    const index = parseInt(match[2], 10);

    if (index > indexSuppression) {
      if (index === 1) {
        parts[parts.length - 1] = prefix.slice(0, -1); // Supprime le dernier underscore
        return parts.join('|');
      }
      parts[parts.length - 1] = `${prefix}${index - 1}`;
      return parts.join('|');
    }

    return idInput;
}
}
